import React from 'react'

interface DrillBitProps {
    refDrill: HTMLInputElement
    x: string | number
}

export default ({ refDrill, x }: DrillBitProps): JSX.Element => (
    <svg
        className={'drill-bit'}
        ref={refDrill}
        width="15"
        height="29"
        x={x ?? '10.36'}
        viewBox="0 0 15 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 0.561279V8H3.11857V14.6696C2.79189 14.614 2.02322 14.7029 1.56202 15.5027C1.10081 16.3026 0.562744 17.4283 0.35136 17.8911C0.216842 18.1688 -0.0406624 19.0464 0.00545789 20.3351C0.0515781 21.6237 0.0246747 23.5011 0.00545789 24.2787L0.581964 25.1119V25.7784H1.33142V26.445L2.13852 26.0561L2.83033 26.2228L3.11857 25.4452L3.81038 26.0561L4.38688 25.7784L4.84809 26.445L5.59754 26.8893V27.5558H6.17404V28.2779H6.75055L7.5 29L8.24945 28.2779H8.82596V27.5558H9.40246V26.8893L10.1519 26.445L10.6131 25.7784L11.1896 26.0562L11.8814 25.4452L12.1697 26.2228L12.8615 26.0562L13.6686 26.445V25.7784H14.418V25.1119L14.9945 24.2787C14.9753 23.5011 14.9484 21.6237 14.9945 20.3351C15.0407 19.0464 14.7832 18.1688 14.6486 17.8911C14.4373 17.4283 13.8992 16.3026 13.438 15.5027C12.9768 14.7029 12.2081 14.614 11.8814 14.6696V8H10V0.561279H7.5H5Z"
            fill="#DDDEE1"
        />
    </svg>
)
